document.addEventListener('DOMContentLoaded', function() {
  // Build chess board
  const board = document.getElementById('chessboard');
  if (board) {
    for (let r = 0; r < 8; r++) {
      for (let c = 0; c < 8; c++) {
        const sq = document.createElement('div');
        sq.className = 'sq ' + ((r + c) % 2 === 0 ? 'light-sq' : 'dark-sq');
        board.appendChild(sq);
      }
    }
  }

  // Add to cart buttons
  document.querySelectorAll('.card-add-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(r => r.json()).then(() => {
        window.location.href = '/cart';
      });
    });
  });
});

// ============================================
// Mobilmeny — hamburger toggle
// ============================================
(function () {
  const hamburger = document.getElementById('nav-hamburger');
  const mobileNav = document.getElementById('mobile-nav');
  const closeBtn  = document.getElementById('mobile-nav-close');
  const backdrop  = document.getElementById('mobile-nav-backdrop');

  if (!hamburger || !mobileNav) return;

  function openMenu() {
    mobileNav.classList.add('open');
    backdrop.classList.add('active');
    hamburger.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileNav.classList.remove('open');
    backdrop.classList.remove('active');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  backdrop.addEventListener('click', closeMenu);

  // Stäng med Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });
})();

// ============================================
// Mobil scroll-reveal (endast mobil — rör aldrig desktop)
// ============================================
(function () {
  if (!window.matchMedia('(max-width: 900px)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll(
    '.section, .product-card, .testimonial-section, .split-banner, .logo-hero'
  );
  if (!targets.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function (el) {
    el.classList.add('reveal');
    io.observe(el);
  });
})();
